import getNotificationIcon from './getNotificationIcon';

export default getNotificationIcon;
